import React from 'react';
import { Button } from 'react-bootstrap';
export default function TableHeader({ headerValue, isBackButton = false }) {
  return (
    <div
       style={{
        display: 'flex', 
        justifyContent: isBackButton ? 'space-between' : 'flex-start',
        alignItems: 'center', 
      }}
      className="page-title-header"
    >
      <h4 className="page-title text-break">{headerValue}</h4>
      {isBackButton && <>{isBackButton()}</>}
    </div>
  );
}
